export const VERSION = '6.49.0'; // x-release-please-version
